module.exports = __webpack_public_path__ + "media/theme/icon__return-795a4a4a.png";